var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$route.path !== "/support"
    ? _c(
        "button",
        {
          staticClass: "support-float-btn bg_color",
          on: { click: _vm.goSupport },
        },
        [_c("span", [_vm._v(_vm._s(_vm.$t("contact_customer_service_text")))])]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }